import Env from '../base/env';
import Channels from '../base/channels';
import { module } from 'modujs';
import Lenis from '@studio-freight/lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { html } from '../utils/environment';

gsap.registerPlugin(ScrollTrigger);

// data-attributes
// data-scroll="item" : to add element as "detectable"
// data-scroll="to" with `href` or `data-href` to add a scrollTo link
// data-scroll-progress-context - value "desktop" or "mobile"

// ScrollTo options
//data-scroll-to-duration
//data-scroll-to-offset
//data-scroll-to-immediate

// data-scroll-id

// Call example : (data-scroll-call, data-scroll-progress-call)
// data-scroll-call="function,moduleName,{moduleId}" - call a function, in the modue "moduleName" with id the id "moduleId"
// OR
// data-scroll-id="myCustomId" data-scroll-call="function,moduleName"  will automatically call myModule with the id : "myCustomId"

// data-scroll-progress-call="function,moduleName,{moduleId}" - call a function on element in viewport updates, in the modue "moduleName" with id the id "moduleId"
// data-scroll-progress-reverse will call progress method from 1 to 0
// data-scroll-progress-css - will set a property --progress to get a css variable on your desired element

// data-scroll-start refered to `start` value of scrollTrigger
// data-scroll-end refered to `end` value of scrollTrigger
// data-scroll-marker
// data-scroll-repeat
// data-scroll-target - trigger when the target element is triggered

//! Exemple pour un module avec un progress géré dans le JS
//? DOM
// data-scroll="item"
// data-module-tonModule="tonId"
// data-scroll-progress-call="onUpdate,TonModule,tonId"

//? JS
// Puis tu fais un module TonModule.js
// Tu crée la function onUpdate() dans ton module
// onUpdate({progress, isReversed}) {
//    console.log(progress, isReversed)
// }

const IN_VIEW_CLASS = 'is-inview';

export default class extends module {
  constructor(m) {
    super(m);

    this.$infinite =
      typeof this.getData('infinite') == 'string'
        ? document.querySelector(this.getData('infinite'))
        : false;

    if (typeof this.getData('infinite') == 'string') {
      const loopElement = this.$infinite;
      const cloneElement = loopElement.cloneNode(true);
      cloneElement.classList.add('clone');

      let scrollElements = cloneElement.querySelectorAll('[data-scroll]');

      scrollElements.forEach((element) => {
        // console.log(element.getAttribute('data-scroll-target'));
        let parent = cloneElement.querySelector(
          `${element.getAttribute('data-scroll-target')}`
        );
        // console.log(parent);
        if (parent != null) {
          parent.setAttribute('id', `${parent.getAttribute('id')}-clone`);
        }
        element.setAttribute(
          'data-scroll-target',
          `${element.getAttribute('data-scroll-target')}-clone`
        );
      });

      this.el.appendChild(cloneElement);
    }

    this.$scrollItems = Array.from(this.$('item'));

    // check if items are outside the container
    this.$scrollOutsideItems = document.querySelectorAll(
      '[data-scroll="outsideItem"]'
    );
    this.$scrollOutsideItems.forEach((outsideItem) => {
      if (
        outsideItem.getAttribute('data-scroll-parent') ==
        this.el.getAttribute('data-module-scroll')
      ) {
        this.$scrollItems.push(outsideItem);
      }
    });

    this.$scrollToWip = this.$('wip')[0];
    this.scrollToItems = this.$('to');
    this.$wrapper =
      typeof this.getData('wrapper') == 'string'
        ? document.querySelector(this.getData('wrapper'))
        : window;
    this.direction =
      typeof this.getData('direction') == 'string'
        ? this.getData('direction')
        : 'vertical';

    this.events = {
      click: {
        to: 'scrollTo',
      },
    };
  }

  init() {
    this.windowWidth = window.innerWidth;

    if (window.isMobile) {
      this.gestureDirection = 'vertical';
      this.direction = 'vertical';
    }

    if (window.isTablet) {
      this.direction = 'vertical';
      this.gestureDirection = 'vertical';
    }

    window.scrollInstance = {
      velocity: 0,
      direction: 'down',
      progress: 0,
    };

    html.setAttribute('data-scroll-direction', this.direction);
    this.initContainerSize();
    this.imagesLoading();

    this.id = this.el.getAttribute('data-module-scroll');

    // console.log(this.getData('infinite'))

    this.lenis = new Lenis({
      wrapper: this.$wrapper,
      content: document.documentElement,
      orientation: this.direction,
      gestureOrientation: this.gestureDirection,
      smoothWheel: true,
      smoothTouch: false,
      duration: 0.7,
      lerp: 0.1,
      wheelMultiplier: 0.7,
      // touchMultiplier: 1.7,
      // touchInertiaMultiplier: 12,
      infinite: typeof this.getData('infinite') == 'string',
    });
    window.scrollObjectInstance = this.lenis;

    //get scroll value
    this.lenis.on(
      'scroll',
      ({ scroll, limit, velocity, direction, progress }) => {
        if (this.id == 'main') {
          ScrollTrigger.update();

          window.scrollInstance = {
            scroll,
            velocity,
            direction: velocity >= 0 ? 'down' : 'up',
            progress,
          };
        }
      }
    );

    this.raf(0);

    if (Env.isVisiting) {
      // console.log('is visiting: in Scroll.js');
      this.lenis.scrollTo('top', {
        immediate: true,
      });
    }

    // Init elements to detect
    gsap.delayedCall(window.readyDelay, () => {
      this.initElements();
    });

    // For Ajax refresh
    Channels.on('scroll::refresh', () => {
      this.removeElements();
      this.$scrollItems = Array.from(this.$('item'));
      this.initElements();
      this.lenis.resize();
      this.refresh();
    });

    // If elements is already in the DOM
    Channels.on('scroll::soft::refresh', () => {
      // console.log('smooth scroll soft refresh');
      this.refresh();
    });

    gsap.delayedCall(window.readyCallbackDelay, () => {
      this.lenis.resize();
      this.refresh();

      if (window.location.hash != '') {
        this.lenis.scrollTo(document.querySelector(window.location.hash));
      } else if (this.$scrollToWip != undefined) {
        this.lenis.scrollTo(this.$scrollToWip);
      }
    });

    // gsap.delayedCall(window.readyCallbackDelay*2,() => {
    //     // this.refresh();
    //     this.lenis.resize();

    //     if(window.location.hash != '') {
    //         this.lenis.scrollTo(document.querySelector(window.location.hash));
    //     }
    //     else if(this.$scrollToWip != undefined) {
    //         this.lenis.scrollTo(this.$scrollToWip);
    //     }
    // });

    this.bindResize = this.resize.bind(this);
    window.addEventListener('resize', this.bindResize);
  }

  initContainerSize() {
    if (this.direction === 'horizontal') {
      let elWidth = 0;

      for (
        let childIndex = 0;
        childIndex < this.el.children.length;
        childIndex++
      ) {
        const child = this.el.children[childIndex];
        elWidth += child.getBoundingClientRect().width;
      }
      this.el.style.setProperty('--scrollContainerWidth', elWidth + 'px');
    }
  }

  imagesLoading() {
    let $images = Array.from(document.getElementsByTagName('img'));
    let count = 0;

    $images.forEach(($image) => {
      $image.addEventListener('load', () => {
        count++;

        if (count == $images.length) {
          this.initContainerSize();
        }
      });
    });
  }

  initElements() {
    this.triggers = new Array(this.$scrollItems.length);
    this.scrollElements = new Array(this.$scrollItems.length);

    this.$scrollItems.forEach(($element, index) => {
      let scrollElement = this.createElement($element, index);
      let hasMarkers =
        typeof $element.getAttribute('data-scroll-marker') == 'string';
      let $target =
        typeof $element.getAttribute('data-scroll-target') == 'string'
          ? document.querySelector($element.getAttribute('data-scroll-target'))
          : $element;

      let options = {
        scroller: this.$wrapper,
        trigger: $target,
        start:
          typeof $element.getAttribute('data-scroll-start') == 'string'
            ? $element.getAttribute('data-scroll-start')
            : 'top bottom',
        end:
          typeof $element.getAttribute('data-scroll-end') == 'string'
            ? $element.getAttribute('data-scroll-end')
            : 'bottom top',
        markers: hasMarkers,
        horizontal: this.direction == 'horizontal',
        onEnter: () => {
          this.onElementEnter(scrollElement, 'down');
        },
        onLeave: () => {
          this.onElementLeave(scrollElement, 'down');
        },
        onEnterBack: () => {
          this.onElementEnter(scrollElement, 'up');
        },
        onLeaveBack: () => {
          this.onElementLeave(scrollElement, 'up');
        },
      };

      if (scrollElement.progressCallParameters != undefined) {
        options = {
          ...options,
          onUpdate: (self) => {
            this.onElementProgress(self, scrollElement);
          },
        };
      }

      if (
        typeof $element.getAttribute('data-scroll-progress-css') == 'string'
      ) {
        $element.style.setProperty('--progress', 0);

        options = {
          ...options,
          onUpdate: (self) => {
            let progress = self.progress.toFixed(3);
            $element.style.setProperty('--progress', progress);
          },
        };
      }

      if (scrollElement.parallaxTl != undefined) {
        options = {
          ...options,
          onUpdate: (self) => {
            scrollElement.parallaxTl.progress(self.progress);
          },
        };
      }

      let sTrigger = ScrollTrigger.create(options);

      this.scrollElements.push({
        ...scrollElement,
        sTrigger,
      });
    });
  }

  createElement($element, index) {
    let id = $element.getAttribute('data-scroll-id');
    let isRepeatable =
      typeof $element.getAttribute('data-scroll-repeat') == 'string';

    // Manage classic call
    let callParameters;
    if (typeof $element.getAttribute('data-scroll-call') === 'string') {
      let callParametersArray = $element
        .getAttribute('data-scroll-call')
        .split(',');
      callParameters = {
        function: callParametersArray[0],
        module: callParametersArray[1],
        moduleId: callParametersArray.length < 3 ? id : callParametersArray[2],
      };
      if (callParameters.moduleId == undefined) {
        console.warn(
          `You didn't specified a data-scroll-id, or a moduleId in your data-scroll-call`,
          $element
        );
      }
    } else {
      callParameters = undefined;
    }

    // Manage progress call
    let progressCallParameters;
    if (
      typeof $element.getAttribute('data-scroll-progress-call') === 'string'
    ) {
      let progressCallParametersArray = $element
        .getAttribute('data-scroll-progress-call')
        .split(',');

      progressCallParameters = {
        function: progressCallParametersArray[0],
        module: progressCallParametersArray[1],
        moduleId:
          progressCallParametersArray.length < 3
            ? id
            : progressCallParametersArray[2],
        isReversed:
          typeof $element.getAttribute('data-scroll-progress-reverse') ==
          'string',
      };
      if (progressCallParameters.moduleId == undefined) {
        console.warn(
          `You didn't specified a data-scroll-id, or a moduleId in your data-scroll-progress-call`,
          this.el
        );
      }
    } else {
      progressCallParameters = undefined;
    }

    let parallax =
      typeof $element.getAttribute('data-scroll-parallax-from') === 'string';
    let parallaxTl;

    if (parallax) {
      parallaxTl = gsap.fromTo(
        $element,
        {
          y: $element.getAttribute('data-scroll-parallax-from'),
        },
        {
          y: $element.getAttribute('data-scroll-parallax-to'),
          duration: 1,
          ease: 'none',
        }
      );
      parallaxTl.pause();
    }

    let progressContext = $element.getAttribute('data-scroll-progress-context');
    if (typeof progressContext == 'string') {
      if (
        (progressContext == 'mobile' && !window.isMobile) ||
        (progressContext == 'desktop' && window.isMobile)
      ) {
        gsap.killTweensOf($element);
        gsap.set($element, { clearProps: 'y,height' });
        progressCallParameters = undefined;
        parallaxTl = undefined;
      }
    }

    return {
      $el: $element,
      id,
      isRepeatable,
      callParameters,
      parallaxTl,
      progressCallParameters,
    };
  }

  onElementProgress(self, scrollElement) {
    let progress = self.progress.toFixed(3);

    this.call(
      scrollElement.progressCallParameters.function,
      {
        progress: parseFloat(progress),
        isReversed: scrollElement.progressCallParameters.isReversed,
      },
      scrollElement.progressCallParameters.module,
      scrollElement.progressCallParameters.moduleId
    );
  }

  onElementEnter(scrollElement, direction) {
    if (
      !scrollElement.isRepeatable &&
      scrollElement.$el.classList.contains(IN_VIEW_CLASS)
    ) {
      return;
    }
    scrollElement.$el.classList.add(IN_VIEW_CLASS);

    // Call js functions in a specific module with data-attribute
    if (scrollElement.callParameters != undefined) {
      this.call(
        scrollElement.callParameters.function,
        { mode: 'enter', direction: direction, $el: scrollElement.$el },
        scrollElement.callParameters.module,
        scrollElement.callParameters.moduleId
      );
    }
  }

  onElementLeave(scrollElement, direction) {
    if (
      !scrollElement.isRepeatable &&
      scrollElement.$el.classList.contains(IN_VIEW_CLASS)
    ) {
      return;
    }
    scrollElement.$el.classList.remove(IN_VIEW_CLASS);

    // Call js functions in a specific module with data-attribute
    if (scrollElement.callParameters != undefined) {
      this.call(
        scrollElement.callParameters.function,
        { mode: 'leave', direction: direction, $el: scrollElement.$el },
        scrollElement.callParameters.module,
        scrollElement.callParameters.moduleId
      );
    }
  }

  raf(time) {
    this.lenis.raf(time);
    this.rafInstance = requestAnimationFrame((time) => this.raf(time));
    // console.log(this.lenis.scroll);
    if (this.lenis.scroll > 200) {
      if (!html.classList.contains('has-scrolled')) {
        html.classList.add('has-scrolled');
      }
    } else {
      if (html.classList.contains('has-scrolled')) {
        html.classList.remove('has-scrolled');
      }
    }
  }

  scrollTo(e) {
    e.preventDefault();
    let target =
      typeof e.currentTarget.getAttribute('href') === 'string'
        ? e.currentTarget.getAttribute('href')
        : e.currentTarget.getAttribute('data-href');
    let duration =
      typeof e.currentTarget.getAttribute('data-scroll-to-duration') == 'string'
        ? parseFloat(e.currentTarget.getAttribute('data-scroll-to-duration'))
        : 2;
    let offset =
      typeof e.currentTarget.getAttribute('data-scroll-to-offset') == 'string'
        ? parseInt(e.currentTarget.getAttribute('data-scroll-to-offset'))
        : 0;
    let immediate =
      typeof e.currentTarget.getAttribute('data-scroll-to-immediate') ==
      'string';
    let easing = (x) =>
      x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;

    this.lenis.scrollTo(target, {
      offset,
      duration,
      immediate,
      easing,
    });
  }

  refresh() {
    if (this.scrollElements != undefined) {
      this.scrollElements.forEach((scrollElement) => {
        scrollElement.sTrigger.refresh();
      });
    }
  }

  resize() {
    if (this.resizeTimeout != undefined) {
      this.resizeTimeout.kill();
    }
    this.resizeTimeout = gsap.delayedCall(0.1, () => {
      this.resizeDebounce();
    });
  }

  resizeDebounce() {
    if (
      this.windowWidth != window.innerWidth ||
      (this.direction == 'horizontal' && !window.isMobile)
    ) {
      this.initContainerSize();
      this.windowWidth = window.innerWidth;
      this.refresh();
    }
  }

  removeElements() {
    this.scrollElements.forEach((scrollElement) => {
      scrollElement.sTrigger.kill();
    });
  }

  destroy() {
    this.lenis.destroy();
    this.scrollElements.forEach((scrollElement) => {
      scrollElement.sTrigger.kill();
    });
    cancelAnimationFrame(this.rafInstance);
    window.removeEventListener('resize', this.bindResize);
  }
}
